import { render, staticRenderFns } from "./BackgroundJobs.vue?vue&type=template&id=78164c48&scoped=true"
import script from "./BackgroundJobs.vue?vue&type=script&lang=js"
export * from "./BackgroundJobs.vue?vue&type=script&lang=js"
import style0 from "./BackgroundJobs.vue?vue&type=style&index=0&id=78164c48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78164c48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78164c48')) {
      api.createRecord('78164c48', component.options)
    } else {
      api.reload('78164c48', component.options)
    }
    module.hot.accept("./BackgroundJobs.vue?vue&type=template&id=78164c48&scoped=true", function () {
      api.rerender('78164c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/BackgroundJobs.vue"
export default component.exports